import http from '../../plugins/axios';

export default {

    /**
     * 创建记录
     * @param data
     * @returns {*}
     */
    create(data) {
        return http.post({
            url: '/admin/coinRebase/create',
            data,
            dataType: 'form'
        })
    },

    /**
     * 确认变基修改余额
     * @param data
     * @returns {*}
     */
    confirmAndChangeBalance(data) {
        return http.post({
            url: '/admin/coinRebase/confirmAndChangeBalance',
            data,
            dataType: 'form'
        })
    },

    /**
     * 删除记录(只能删除新创建的记录，确认变基和转账完成不能删除)
     * @param data
     * @returns {*}
     */
    delete(data) {
        return http.post({
            url: '/admin/coinRebase/delete',
            data,
            dataType: 'form'
        })
    },

    /**
     * 变基情况
     * @param data
     * @returns {*}
     */
    info(data) {
        return http.get({
            url: '/admin/coinRebase/info',
            data
        })
    },

    /**
     * 查询
     * @param data
     * @returns {*}
     */
    list(data) {
        return http.get({
            url: '/admin/coinRebase/list',
            data
        })
    }
}